import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RegistrationRoutingModule } from './registration-routing.module';
import { RegistrationResolver } from './registration-resolver';
import { RegistrationComponent } from './registration/registration.component';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { ExtendedModule, FlexModule } from '@angular/flex-layout';
import { MatStepperModule } from '@angular/material/stepper';
import { ReactiveFormsModule } from '@angular/forms';
import { ClientDetailsModule } from '../client-details/client-details.module';
import { PatientsModule } from '../patients/patients.module';
import { ManageRegistrationPatientsComponent } from './manage-registration-patients/manage-registration-patients.component';
import { AdditionalRegistrationInfoComponent } from './additional-registration-info/additional-registration-info.component';
import { RegistrationContactEntriesComponent } from './registration-contact-entries/registration-contact-entries.component';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { RegistrationSummaryComponent } from './registration-summary/registration-summary.component';
import { CommonComponentsModule } from '../components/common-components/common-components.module';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';

@NgModule({
  declarations: [
    RegistrationComponent,
    ManageRegistrationPatientsComponent,
    AdditionalRegistrationInfoComponent,
    RegistrationContactEntriesComponent,
    RegistrationSummaryComponent,
  ],
  imports: [
    CommonModule,
    RegistrationRoutingModule,
    MatCardModule,
    MatInputModule,
    MatButtonModule,
    FlexModule,
    MatStepperModule,
    ReactiveFormsModule,
    ClientDetailsModule,
    PatientsModule,
    MatCheckboxModule,
    MatIconModule,
    MatSelectModule,
    CommonComponentsModule,
    MatProgressSpinnerModule,
    ExtendedModule,
  ],
  providers: [RegistrationResolver],
})
export class RegistrationModule {}
